// KnowledgeBase Quasar-style Callouts plugin
// Enhances existing callouts (.kb-callout) produced by the core callouts plugin
// to appear like Quasar banners (icon, tinted background, smoother spacing),
// without mounting Vue components.

import { registerMarkdownPostProcessor } from '../../services/PluginAPI.js'
import './styles/callouts.css'

const ICONS = {
  info: 'info',
  tip: 'lightbulb',
  success: 'check_circle',
  question: 'help',
  warning: 'warning',
  failure: 'error',
  bug: 'bug_report',
  example: 'article',
  quote: 'format_quote'
}

function enhance(callout) {
  if (!callout || callout.__kb_qcallout_applied) return
  callout.__kb_qcallout_applied = true

  callout.classList.add('kb-qcallout')

  const title = callout.querySelector('.kb-callout-title')
  if (title && !title.querySelector('.kb-qcallout-icon')) {
    const iconWrap = document.createElement('span')
    iconWrap.className = 'kb-qcallout-icon'

    // Determine type from class name kb-callout-*
    let type = 'info'
    for (const cls of Array.from(callout.classList)) {
      if (cls.startsWith('kb-callout-')) {
        type = cls.replace('kb-callout-', '')
        break
      }
    }
    const iconName = ICONS[type] || ICONS.info
    // Use material icon font if present; otherwise fallback text
    const i = document.createElement('i')
    i.className = 'material-icons'
    i.textContent = iconName
    iconWrap.appendChild(i)
    title.prepend(iconWrap)
  }
}

export function registerQuasarCalloutsPlugin() {
  // Run after core callouts (which uses sortOrder 50)
  registerMarkdownPostProcessor(
    (root) => {
      const nodes = Array.from(root.querySelectorAll('.kb-callout'))
      for (const n of nodes) {
        try {
          enhance(n)
        } catch {}
      }
    },
    { sortOrder: 55 }
  )
}

export default { registerQuasarCalloutsPlugin }
